module.exports = __webpack_public_path__ + "media/packs/images/fetch-2c50e21592ae9c3ca367f2999e55b69e.gif";